"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltipTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTooltipTitle = styled_components_1.default.span `
  padding: ${({ theme }) => theme.spacing(1.5)};
  font-size: 0.75rem;
`;
